import '../assets/App.css';
import { RouterProvider } from 'react-router-dom';
import AppRouter from './AppRouter';
import AuthProvider from '../provider/AuthProvider';

function App() {
    return (
        <AuthProvider>
            <RouterProvider router={AppRouter} />
        </AuthProvider>
    );
}

export default App;
